/* MemoriesxBloom — scroll choreography.
   Progressive enhancement only: without GSAP (or with reduced motion)
   every element stays fully visible and static. */
(function () {
  'use strict';

  function init() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Scroll cue: clicking "Scroll ↓" glides to the section below the hero.
       Hand-rolled rAF ease instead of scrollIntoView({behavior:'smooth'}) —
       smooth-behavior support is inconsistent across engines/webviews. */
    document.querySelectorAll('[data-mxb-scroll-cue]').forEach(function (cue) {
      cue.addEventListener('click', function () {
        var wrapper = cue.closest('.shopify-section') || cue.closest('.mxb-hero');
        var next = wrapper ? wrapper.nextElementSibling : null;
        var targetY = next
          ? next.getBoundingClientRect().top + window.pageYOffset
          : window.pageYOffset + window.innerHeight;

        if (reduceMotion) {
          window.scrollTo(0, targetY);
          return;
        }

        var startY = window.pageYOffset;
        var dist = targetY - startY;
        var t0 = null;
        var DURATION = 700;
        var started = false;

        function step(ts) {
          started = true;
          if (t0 === null) t0 = ts;
          var p = Math.min((ts - t0) / DURATION, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          window.scrollTo(0, startY + dist * eased);
          if (p < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);

        /* Throttled/hidden contexts freeze rAF — land instantly instead. */
        window.setTimeout(function () {
          if (!started) window.scrollTo(0, targetY);
        }, 200);
      });
    });

    if (reduceMotion || !window.gsap) return;

    var gsap = window.gsap;
    if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

    /* ---- Hero: word-mask headline rise + media settle ---- */
    document.querySelectorAll('[data-mxb-hero]').forEach(function (hero) {
      var heading = hero.querySelector('[data-mxb-split]');
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      var media = hero.querySelector('.mxb-hero__media img, .mxb-hero__media svg');
      if (media) {
        tl.fromTo(media, { scale: 1.12 }, { scale: 1, duration: 2.4, ease: 'power2.out' }, 0);
      }

      if (heading) {
        splitWords(heading);
        tl.fromTo(
          heading.querySelectorAll('.mxb-word-inner'),
          { yPercent: 115 },
          { yPercent: 0, duration: 1.1, stagger: 0.055 },
          0.25
        );
      }

      var rest = hero.querySelectorAll('[data-mxb-hero-fade]');
      if (rest.length) {
        tl.fromTo(rest, { autoAlpha: 0, y: 28 }, { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.12 }, 0.8);
      }

      /* Gentle parallax drift as the hero scrolls away */
      if (media && window.ScrollTrigger) {
        gsap.to(media, {
          yPercent: 12,
          ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
        });
      }
    });

    if (!window.ScrollTrigger) return;

    /* ---- Generic fade-up reveals ---- */
    document.querySelectorAll('[data-mxb-reveal]').forEach(function (el) {
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 36 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 86%' }
        }
      );
    });

    /* ---- Staggered children ---- */
    document.querySelectorAll('[data-mxb-stagger]').forEach(function (group) {
      var items = group.children;
      if (!items.length) return;
      gsap.fromTo(
        items,
        { autoAlpha: 0, y: 44 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          stagger: 0.12,
          ease: 'power3.out',
          scrollTrigger: { trigger: group, start: 'top 84%' }
        }
      );
    });

    /* ---- Image parallax inside masks ---- */
    document.querySelectorAll('[data-mxb-parallax-frame]').forEach(function (frame) {
      var img = frame.querySelector('img, svg');
      if (!img) return;
      gsap.fromTo(
        img,
        { yPercent: -6 },
        {
          yPercent: 6,
          ease: 'none',
          scrollTrigger: {
            trigger: frame,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        }
      );
    });

    /* ---- Process rail line draw ---- */
    document.querySelectorAll('[data-mxb-process]').forEach(function (rail) {
      var fill = rail.querySelector('.mxb-process__line-fill');
      if (!fill) return;
      gsap.to(fill, {
        scaleY: 1,
        ease: 'none',
        scrollTrigger: { trigger: rail, start: 'top 70%', end: 'bottom 65%', scrub: 0.6 }
      });
    });
  }

  /* Wrap each word of a heading in masked spans for the rise reveal.
     Plain-text only — headings with markup are left intact. */
  function splitWords(el) {
    if (el.dataset.mxbSplitDone || el.children.length) return;
    var words = (el.textContent || '').trim().split(/\s+/);
    if (!words.length) return;
    el.textContent = '';
    el.classList.add('mxb-split');
    words.forEach(function (word, i) {
      var mask = document.createElement('span');
      mask.className = 'mxb-word';
      var inner = document.createElement('span');
      inner.className = 'mxb-word-inner';
      inner.textContent = word;
      mask.appendChild(inner);
      el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.dataset.mxbSplitDone = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
